import type { ComponentProps } from 'react'
import CbamReportLiabilityEstimatorLayout from './components/CbamReportLiabilityEstimatorLayout'
import ImportedGoodsSection from './components/ImportedGoodsSection'

type Props = {
  layout: Omit<ComponentProps<typeof CbamReportLiabilityEstimatorLayout>, 'children'>
  importedGoods: ComponentProps<typeof ImportedGoodsSection>
}

export default function CbamReportDetailsEstimatorView({ layout, importedGoods }: Props) {
  return (
    <CbamReportLiabilityEstimatorLayout {...layout}>
      <ImportedGoodsSection {...importedGoods} />
    </CbamReportLiabilityEstimatorLayout>
  )
}
